import {Injectable, Injector} from '@angular/core';
import {Http, Response} from '@angular/http';
import {ApiConnectService} from './api-connect.service';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {Observable} from 'rxjs/Observable';
import {ReportService} from './report.service';

@Injectable()
export class NotificationsService {
  nearNitification = null;
  private operatingStandsNotificationCount = 187;

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private reports: ReportService) {

  }

  get payrollReportsInvalidated$(): Observable<void> { return this.reports.payrollReportsInvalidated$; }

  getNearNotificationFromAPI() {
    this.clearNearNotification();
    this.clearLocalNearNoitify();
    this.http.get(this.apiURL.getNearExNotification, {observe: 'response'}).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.setNearNotification(res.body);
        } else {
          this.clearNearNotification();
        }
      },
      () => {
        this.clearNearNotification();
      }
    );
  }

  setNearNotification(nNotify) {
    this.nearNitification = nNotify;
    this.setLocalNearNoitify();
  }

  getNearNotification() {
    if (this.getLocalNearNoitify() !== null) {
      this.nearNitification = this.getLocalNearNoitify();
      this.setDaysField(this.nearNitification);
      this.renameTypes(this.nearNitification);
    }

    return this.nearNitification;
  }

  clearNearNotification() {
    this.nearNitification = null;
    this.clearLocalNearNoitify();
  }


  // OK
  // ADDED_SUGGESTION_FOR_REVIEW
  // SUGGESTION_CANCELLED
  // SUGGESTION_IMPLEMENTED
  // SUGGESTION_POSTPONED
  // SUGGESTION_REASSIGNED
  // SUGGESTION_POSTPONE_EXPIRED
  // ALL_SUGGESTION_TASKS_DONE
  // SUGGESTION_TASK_WORK
  // SUGGESTION_TASKS_EXPIRED
  renameTypes(i) {
    if (i.type === 'CONFIRMATION_STARTED') {
      i.type = 'CONFIRMATION STARTED';
    } else if (i.type === 'MODIFY_REQUEST') {
      i.type = 'MODIFY REQUEST';
    } else if (i.type === 'CONFIRMATION_FINISHED') {
      i.type = 'CONFIRMATION FINISHED';
    } else if (i.type === 'CONF_CHAT_MESSAGE') {
      i.type = 'NEW MESSAGE';
    } else if (i.type === 'FAMILIARIZATION_STARTED') {
      i.type = 'FAMILIARIZATION STARTED';
    } else if (i.type === 'FAMILIARIZATION_FINISHED') {
      i.type = 'FAMILIARIZATION FINISHED';
    } else if (i.type === 'MODIFICATION_DONE') {
      i.type = 'MODIFICATION DONE';
    } else if (i.type === 'TESTING_STARTED') {
      i.type = 'TESTING STARTED';
    } else if (i.type === 'ADDED_SUGGESTION_FOR_REVIEW') {
      i.type = 'ADDED SUGGESTION FOR REVIEW';
    } else if (i.type === 'SUGGESTION_CANCELLED') {
      i.type = 'SUGGESTION CANCELLED';
    } else if (i.type === 'SUGGESTION_IMPLEMENTED') {
      i.type = 'SUGGESTION IMPLEMENTED';
    } else if (i.type === 'SUGGESTION_POSTPONED') {
      i.type = 'SUGGESTION POSTPONED';
    } else if (i.type === 'SUGGESTION_REASSIGNED') {
      i.type = 'SUGGESTION REASSIGNED';
    } else if (i.type === 'SUGGESTION_POSTPONE_EXPIRED') {
      i.type = 'SUGGESTION POSTPONE EXPIRED';
    } else if (i.type === 'ALL_SUGGESTION_TASKS_DONE') {
      i.type = 'ALL SUGGESTION TASKS DONE';
    } else if (i.type === 'SUGGESTION_TASK_WORK') {
      i.type = 'SUGGESTION TASK WORK';
    } else if (i.type === 'SUGGESTION_TASKS_EXPIRED') {
      i.type = 'SUGGESTION TASKS EXPIRED';
    }
  }

  setDaysField(item) {
    if (item.expiringDate !== '') {
      const expiringDateConst = moment(item.expiringDate, 'DD.MM.YYYY').startOf('day');
      const currentDate = moment().startOf('day');
      item.days = expiringDateConst.diff(currentDate, 'days');
    }
  }

  setLocalNearNoitify() {
    localStorage.setItem('NearNotify', JSON.stringify(this.nearNitification));
  }

  getLocalNearNoitify() {
    return JSON.parse(localStorage.getItem('NearNotify'));
  }

  clearLocalNearNoitify() {
    localStorage.removeItem('NearNotify');
  }


  // UPDATE NOTIFICATION COUNT NUMBER;
  public getOperatingStandsNotifications() {
    return this.operatingStandsNotificationCount;
  }

  private setOperatingStandsNotifications(count) {
    this.operatingStandsNotificationCount = count;
  }


  public readNotification(nCategory, nID, notifID) {
    const readNotificationInputResource = {
      id: notifID
    };

    this.http.post(this.apiURL.readNotificationByCategoryAndID, readNotificationInputResource, {observe: 'response'}).subscribe(
      (res: any) => {
      },
      () => {
      }
    );
  }


}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/notifications.service.ts